import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { SharedModule } from '../../shared/shared.module'
// Components
import { FilterComponent } from './filter.component'

/** Module that exposes all filter-related components to the application */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    // Only declare non-standalone components
    FilterComponent,
  ],
  exports: [
    // Export the main component and re-export the components module
    FilterComponent,
  ],
})
export class FilterModule {}
